export const askForPriceleadButtonCopy = "Odkryj cenę";
export const askForOfferLeadButtonCopy = "Odkryj cenę";
export const askForPriceleadButtonCopy = "Odkryj cenę";
export const askForOfferLeadButtonCopy = "Odkryj cenę";
